import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('reports.data.filters.referenceValueFilter', {
    nullableBooleanOptionTextYes: 'Yes',
    nullableBooleanOptionTextNo: 'No',
});
